<app-reports *ngIf="english"></app-reports>
<app-reports-hindi *ngIf="hindi"></app-reports-hindi>